import { useState } from 'react';
import type { AsyncSearchFieldProps } from '@vox/frontend-react-ui/async-search';
import { AsyncSearchField } from '@/shared/ui/AsyncSearchField';
import { formatRussianPhoneInput, isValidRussianPhone } from '@/shared/lib/phone';
import { PersonSearchMode, type PersonSearchModeValue } from '@/shared/ui/PersonSearchMode/PersonSearchMode';
import classes from './PersonSearchField.module.scss';

/** Настройки поиска человека */
type PersonSearchFieldProps<TData> = Omit<AsyncSearchFieldProps<string, TData>, 'toolbar'>;

/** Предоставляет единый поиск человека по имени или телефону */
export const PersonSearchField = <TData,>(props: PersonSearchFieldProps<TData>) => {
    const [mode, setMode] = useState<PersonSearchModeValue>('name');
    const byPhone = mode === 'phone';

    return <AsyncSearchField<string, TData>
        {...props}
        key={mode}
        panelClassName={[classes.panel, props.panelClassName].filter(Boolean).join(' ')}
        toolbar={!props.value &&
            <PersonSearchMode
                mode={mode}
                onChange={setMode}
                disabled={props.disabled}
            />
        }
        placeholder={byPhone
            ? '+7 (___) ___-__-__'
            : props.placeholder
        }
        minSearchLength={byPhone
            ? 2
            : props.minSearchLength
        }
        formatInput={byPhone
            ? formatRussianPhoneInput
            : undefined
        }
        isQueryValid={byPhone
            ? isValidRussianPhone
            : undefined
        }
        incompleteQueryMessage={byPhone
            ? 'Введите полный номер телефона'
            : undefined
        }
        inputMode={byPhone
            ? 'tel'
            : 'text'
        }
    />;
};
